export default {
    vsmList: [],
    vsmLists:{},
    domains: [],
    domain:{},
};